import { Component, Input, ViewChild } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { IconWithLabelComponent } from './icon-with-label.component';
import { MenuItem, MenuItemType } from './menu-item.types';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'hk-app-menu-item',
  template: `
    <mat-menu #childMenu="matMenu" [overlapTrigger]="false">
      <ng-container *ngFor="let child of items">
        <!-- Handle branch node menu items -->
        <ng-container *ngIf="child.children && child.children.length > 0; else leaf">
          <ng-container *ngIf="!(child.hidden && child.hidden())">
            <button
              mat-menu-item
              color="primary"
              [matMenuTriggerFor]="menu.childMenu"
              [disabled]="Boolean(child.disabled && child.disabled(child))"
              [matTooltip]="child.i18nKeyTooltip ? (child.i18nKeyTooltip | translate) : undefined"
              [matTooltipPosition]="child.keyTooltipPosition ?? 'below'"
              matTooltipTouchGestures="off"
              [attr.data-testid]="'menuItem.' + child.i18nKey"
            >
              <hk-icon-with-label iconClass="{{ child.iconName }}" text="{{ child.i18nKey | translate }}"></hk-icon-with-label>
            </button>
            <hk-app-menu-item #menu [items]="child.children"></hk-app-menu-item>
          </ng-container>
        </ng-container>
        <!-- Handle leaf node menu items -->
        <ng-template #leaf>
          <ng-container *ngIf="!(child.hidden && child.hidden())">
            <p *ngIf="child.type === menuItemType.Footer; else leafButton" class="menuFooter">{{ child.i18nKey | translate }}</p>
            <ng-template #leafButton>
              <button
                mat-menu-item
                color="primary"
                (click)="child.callback && child.callback()"
                [class.is-active]="child.isSelected && child.isSelected(child)"
                [disabled]="Boolean(child.disabled && child.disabled(child))"
                [matTooltip]="child.i18nKeyTooltip ? (child.i18nKeyTooltip | translate) : undefined"
                [matTooltipPosition]="child.keyTooltipPosition ?? 'below'"
                matTooltipTouchGestures="off"
                [attr.data-testid]="'menuItem.' + child.i18nKey"
              >
                <hk-icon-with-label
                  iconClass="{{ child.iconName }}"
                  text="{{ child.i18nKey | translate: child.i18nParams }}"
                ></hk-icon-with-label>
              </button>
            </ng-template>
          </ng-container>
        </ng-template>
      </ng-container>
    </mat-menu>
  `,
  styles: [
    `
      .is-active,
      .is-active:hover {
        background-color: #80b70980;
      }

      .menuFooter {
        color: #868685;
        margin: 0 16px;
        float: right;
        display: inline-block;
      }

      ::ng-deep .mat-mdc-menu-content {
        padding: 0 !important;
      }
    `,
  ],
  standalone: true,
  imports: [MatMenu, MatMenuTrigger, MatTooltip, TranslateModule, IconWithLabelComponent, MatMenuItem, NgForOf, NgIf],
})
export class MenuItemComponent {
  @Input() items!: MenuItem[];
  @ViewChild('childMenu', { static: true }) childMenu!: MatMenu;

  protected menuItemType = MenuItemType;
  protected readonly Boolean = Boolean;

  constructor(public router: Router) {}
}
